import { FILES_URL } from '@/shared/lib/const'
import { Checkbox } from '@/shared/ui'

import cl from './style.module.scss'

const CHECKBOX_ID = 'rule-policy-checkbox'

type RuleCheckboxProps = {
	checked: boolean
	disabled?: boolean
	onChange: (checked: boolean) => void
}

export const RuleCheckbox = ({ checked, disabled, onChange }: RuleCheckboxProps) => {
	return (
		<div className={cl.root}>
			<Checkbox id={CHECKBOX_ID} checked={checked} onChange={e => onChange(e.target.checked)} disabled={disabled} />
			<label htmlFor={CHECKBOX_ID} className={cl.text}>
				Я прочитал(а), ознакомился(лась) и согласен(на) с
				<a
					href={`${FILES_URL}/NBC_web-policy.pdf`}
					title="Ознакомиться с политикой конфиденциальности (pdf)"
					target="_blank">
					{' политикой конфиденциальности '}
				</a>
				и
				<a
					href={`${FILES_URL}/NBC_web-consest.pdf`}
					title="Ознакомиться с согласием на обработку персональных данных (pdf)"
					target="_blank">
					{' обработкой персональных данных '}
				</a>
			</label>
		</div>
	)
}
